import { ISkill } from "@/types/skill";
import { MasterData } from "./masterData";

export class Skill extends MasterData implements ISkill {
  public readonly company_id = 0;
}
